// @ts-nocheck
// TODO: npm i --save-dev @types/react-loadable
import Loadable from 'react-loadable';
import { CommonLoadable } from './utils';

export const Program = Loadable({
  ...CommonLoadable,
  loader: () => import('../routes/program'),
});
